import { createContext, useContext } from "react";

const PermissionsContext = createContext();
export const usePermissionsContext = () => useContext(PermissionsContext);

export default PermissionsContext;
